import SmartBankAccountFilter from "./SmartBankAccountFilter";

export default SmartBankAccountFilter;
export * from "./SmartBankAccountFilter";
